<ion-menu side="end" type="overlay" contentId="reborn" menuId="rebornMenu">
    <span class="arrow-icon"></span>
    <ion-content class="reborn-menu" [scrollY]="false" type="reveal">
      <ion-list class="menu">
        <ion-accordion-group>
          <ion-item class="no-accordion" button (click)="navigateTo('/home')">
            <ion-label>{{ 'Home' | translate }}</ion-label>
          </ion-item>
          <ion-accordion value="find-property" toggleIcon="/assets/icon/office/icon-chevron-forward.svg">
            <ion-item slot="header">
              <ion-label>{{ 'find-property' | translate }}</ion-label>
            </ion-item>
            <div class="ion-padding" slot="content">
              @for (find_property of find_properties; track find_property.id) {
              <ion-item button (click)="navigateTo(find_property.url)">
                <ion-label>{{ find_property.name | translate }}</ion-label>
              </ion-item>
              }
            </div>
          </ion-accordion>
          <ion-item class="no-accordion" button (click)="navigateTo('/proyek-rumah')">
            <ion-label>{{ 'new-property' | translate }}</ion-label>
          </ion-item>
          <ion-accordion value="info-property" toggleIcon="/assets/icon/office/icon-chevron-forward.svg">
            <ion-item slot="header">
              <ion-label>{{ 'info-property' | translate }}</ion-label>
            </ion-item>
            <div class="ion-padding" slot="content">
              @for (info of info_property; track info.id) {
              <ion-item button (click)="navigateTo(info.url)">
                <ion-label>{{ info.name | translate }}</ion-label>
              </ion-item>
              }
            </div>
          </ion-accordion>
          <ion-accordion value="join-ljh-realty" toggleIcon="/assets/icon/office/icon-chevron-forward.svg">
            <ion-item slot="header">
              <ion-label>{{ 'join-ljh-realty' | translate }}</ion-label>
            </ion-item>
            <div class="ion-padding" slot="content">
              @for (business of businesses; track business.id) {
              <ion-item button (click)="navigateTo(business.url)">
                <ion-label>{{ business.name | translate }}</ion-label>
              </ion-item>
              }
            </div>
          </ion-accordion>
          
          <ion-accordion value="about-us" toggleIcon="/assets/icon/office/icon-chevron-forward.svg">
            <ion-item slot="header">
              <ion-label>{{ 'about-us' | translate }}</ion-label>
            </ion-item>
            <div class="ion-padding" slot="content">
              @for (about_us of about_uses; track about_us.id) {
              <ion-item button (click)="navigateTo(about_us.url)">
                <ion-label>{{ about_us.name | translate }}</ion-label>
              </ion-item>
              }
            </div>
          </ion-accordion>
        </ion-accordion-group>
        <ion-item lines="none" class="line-none">
          <button class="contact-us" (click)="contactUs()">
            <ion-icon name="call"></ion-icon> {{ 'contact-us' | translate }}
          </button>
        </ion-item>
        <ion-item lines="none" class="line-none">
          <ion-label id="lang-label">
            <span (click)="switchId($event)" [class.highlight]="translate.currentLang === 'id'">Ind</span> |
            <span (click)="switchEn($event)" [class.highlight]="translate.currentLang === 'en'">Eng</span>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
</ion-menu>

<div id="reborn" class="ion-page main-layout">
  <app-header></app-header>
  <ion-content>
     <ion-router-outlet></ion-router-outlet>
  </ion-content>
</div>
